"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _Shadows = _interopRequireDefault(require("../../Basic/Shadows/Shadows"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _excluded = ["title", "label", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)({
  anchor: {
    textDecoration: 'underline',
    textDecorationStyle: 'dashed',
    textDecorationColor: _Colors.default.sinineVaal,
    cursor: 'pointer'
  }
});
var useStylesTooltip = (0, _styles.makeStyles)({
  arrow: {
    color: _Colors.default.vagaVesi
  },
  tooltip: {
    backgroundColor: _Colors.default.vagaVesi,
    boxShadow: _Shadows.default.shadow2,
    padding: 10
  }
});

function Tooltip(_ref) {
  var title = _ref.title,
      label = _ref.label,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var tooltipClasses = useStylesTooltip();

  if (!title) {
    return !!children ? children : label;
  }

  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({
    arrow: true,
    classes: tooltipClasses,
    title: title
  }, rest), !!children ? children : /*#__PURE__*/_react.default.createElement("span", {
    className: classes.anchor
  }, label));
}